import { ReactNode } from 'react'
import { Skeleton } from './styled'

type SkeletonListProps = {
  count: number
  skeletonHeight?: number
  itemMarginBottom?: string
  skeletonNode?: ReactNode
}

export function SkeletonList({
  count,
  skeletonHeight = 118,
  itemMarginBottom,
  skeletonNode,
}: SkeletonListProps) {
  const skeletons = []

  for (let i = 0; i < count; i++) {
    skeletons.push(
      skeletonNode || (
        <Skeleton $height={skeletonHeight} style={{ borderRadius: '12px' }} />
      ),
    )
  }

  return (
    <div>
      {skeletons.map((skeleton, index) => (
        <div
          key={index}
          style={{
            ...(itemMarginBottom ? { marginBottom: itemMarginBottom } : {}),
          }}
        >
          {skeleton}
        </div>
      ))}
    </div>
  )
}
